import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import CloseIcon from '../../assets/image/close.svg';
import TickIcon from '../../assets/image/tick.svg';
import { RiLink } from 'react-icons/ri';
import { useSelector } from 'react-redux';
import { Tooltip } from 'bootstrap';

const InputField = ({
	value,
	label,
	placeholder,
	type,
	onChange,
	error,
	required = false,
	maxLength = null,
	name,
	autoFocus,
	autoComplete,
	onKeyPress,
	infoIcon,
	showPasswordIcon,
	toolTip,
	disabled,
	onClick,
	showValidateIcon,
	otherDiv,
	rightIcon,
	showPasswordIconWithoutLabel,
	rightText,
	tolipIcon = null,
	multiline = false,
	rows = 1,
	...rest
}) => {
	const inputRef = useRef(null);
	const [showPassword, setShowPassword] = useState(false);
	const user = useSelector((state) => state?.userInfo?.userInfo?.data);

	useEffect(() => {
		if (autoFocus && inputRef.current) {
			inputRef.current.focus();
		}
	}, [autoFocus]);

	const [isPopupVisible, setIsPopupVisible] = useState(false);

	const getTextFromHTML = (html) => {
		const div = document.createElement('div');
		div.innerHTML = html;
		return div.textContent || div.innerText || '';
	};

	const handleChange = (e) => {
		let { value } = e.target;
		const plainText = getTextFromHTML(label);
		if (
			!plainText.includes('Email') &&
			plainText !== 'Password' &&
			placeholder !== 'Password' &&
			user?.settings?.general_preferences?.enable_auto_capitalize_input?.value
		) {
			value = value.toUpperCase();
		}
		onChange(value);
	};

	const toggleInfoIcon = () => {
		setIsPopupVisible(!isPopupVisible);
		if (onClick) {
			onClick(!isPopupVisible);
		}
	};

	const togglePasswordVisibility = () => {
		setShowPassword(!showPassword);
	};

	useEffect(() => {
		if (tolipIcon) {
			const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');

			[...tooltipTriggerList].forEach((tooltipTriggerEl) => new Tooltip(tooltipTriggerEl));
		}
	}, []);

	return (
		<div className="form-group position-relative">
			{label && (
				<label
					style={{
						display: 'flex',
						alignItems: 'center',
						gap: 5,
					}}
					className="form-label"
					htmlFor={`input-field-${name}`}
				>
					{label}
					{label === 'Website URL' && value && (
						<a
							rel="noreferrer"
							href={value.startsWith('http') ? value : `http://${value}`}
							target="_blank"
						>
							<RiLink />
						</a>
					)}
					{required && <span style={{ color: 'red' }}>*</span>}
					{tolipIcon && (
						<span className="px-2">
							<img
								src={tolipIcon.icon}
								className="cursor-pointer"
								alt="info"
								width={15}
								height={15}
								data-bs-toggle="tooltip"
								data-bs-placement="right"
								title={tolipIcon.title}
							/>
						</span>
					)}
				</label>
			)}
			{infoIcon && (
				<i
					data-tooltip-id="my-tooltip-1"
					onClick={toggleInfoIcon}
					className="fa fa-info-circle"
					style={{
						cursor: 'pointer',
						Size: '1.4rem',
						color: 'var(--brand-color)',
						marginLeft: '.2rem',
					}}
				></i>
			)}

			{multiline ? (
				<textarea
					style={{ width: '100%', border: error ? '1px solid #f71326' : '' }}
					value={value}
					className={`inpuBG ${error ? 'border border-danger' : ''} focus`}
					placeholder={placeholder}
					autoComplete={autoComplete}
					onChange={handleChange}
					name={name}
					ref={inputRef}
					id={`input-field-${name}`}
					rows={rows}
					disabled={disabled}
					{...rest}
				/>
			) : (
				<div
					style={{
						border: error ? '1px solid #f71326' : '',
						borderRadius: '8px',
						height: '38px',
					}}
					className=""
				>
					<input
						value={value}
						className={`form-control mb-lg-4 mb-md-3 mb-sm-3 mb-3 inpuBG ${
							error ? 'border-red' : ''
						} focus`}
						placeholder={placeholder}
						autoComplete={autoComplete}
						onChange={handleChange}
						maxLength={maxLength}
						name={name}
						pattern={type === 'number' ? '[0-9]' : ''}
						ref={inputRef}
						id={`input-field-${name}`}
						onKeyDown={onKeyPress}
						type={type === 'password' ? (showPassword ? 'text' : 'password') : type}
						disabled={disabled}
						{...rest}
					/>
				</div>
			)}

			{error && (
				<div
					className="error-text"
					style={{ color: 'red', fontSize: '12px', marginBottom: '10px' }}
				>
					{error}
				</div>
			)}

			{showPasswordIcon && (
				<i
					className={`fa ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}
					onClick={togglePasswordVisibility}
					style={{
						position: 'absolute',
						right: '1rem',
						top: showPasswordIconWithoutLabel ? '1rem' : '3.9rem',
						cursor: 'pointer',
					}}
				/>
			)}

			{showValidateIcon && (
				<>
					{!!error ? (
						<div style={{ position: 'absolute', right: '1rem', top: '3.3rem', cursor: 'pointer' }}>
							<img
								src={CloseIcon}
								alt="close icon"
							/>
						</div>
					) : (
						value?.length > 3 && (
							<div
								style={{ position: 'absolute', right: '1rem', top: '3.3rem', cursor: 'pointer' }}
							>
								<img
									src={TickIcon}
									alt="close icon"
								/>
							</div>
						)
					)}
				</>
			)}
			{otherDiv && (
				<div
					style={{
						position: 'absolute',
						right: '0px',
						top: '65%',
						transform: 'translateY(-50%)',
						backgroundColor: 'red',
						width: '29px',
						height: '35px',
						borderRadius: ' 0px 8px 8px 0px',
						border: '1px solid var(--sub-stroke-15, rgba(85, 91, 103, 0.15))',
						backgroundColor: '#EDEDF7',
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
					}}
				>
					{otherDiv}
				</div>
			)}

			{rightIcon && (
				<div
					style={{
						position: 'absolute',
						right: '1rem',
						top: '43px',
						transform: 'translateY(-50%)',
						cursor: 'pointer',
					}}
					onClick={rightIcon.onClick}
				>
					<img
						onClick={rightIcon.onClick}
						src={rightIcon.src}
						alt={rightIcon.alt}
						style={{
							width: '20px',
							height: '20px',
						}}
					/>
				</div>
			)}
			{rightText && (
				<div
					style={{
						position: 'absolute',
						right: '1rem',
						top: '16px',
						transform: 'translateY(-50%)',
						cursor: 'pointer',
						color: rightText.color,
					}}
					onClick={rightText.onClick}
				>
					{rightText.title}
				</div>
			)}
		</div>
	);
};

InputField.propTypes = {
	value: PropTypes.string.isRequired || PropTypes?.number.isRequired,
	label: PropTypes.string,
	placeholder: PropTypes.string,
	type: PropTypes.string,
	onChange: PropTypes.func.isRequired,
	error: PropTypes.string,
	required: PropTypes.bool,
	name: PropTypes.string,
	autoFocus: PropTypes.bool,
	multiline: PropTypes.bool,
	autoComplete: PropTypes.string,
	rightIcon: PropTypes.shape({
		src: PropTypes.string.isRequired,
		alt: PropTypes.string.isRequired,
		onClick: PropTypes.func,
	}),
	rightText: PropTypes.shape({
		title: PropTypes.string.isRequired,
		color: PropTypes.string.isRequired,
		onClick: PropTypes.func,
	}),
};

InputField.defaultProps = {
	label: '',
	placeholder: '',
	type: 'text',
	error: '',
	required: false,
	autoFocus: false,
	multiline: false,
	autoComplete: 'on',
	rightIcon: null,
	rightText: null,
};

export default InputField;
